import { Music } from 'lucide-react';

export function SongsPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <Music className="text-zelda-gold" size={28} />
        <h1 className="text-2xl font-bold text-zelda-gold">Song Tracker</h1>
      </div>

      <p className="text-gray-400 text-sm">
        Song tracking is being migrated to the new architecture. Check back soon!
      </p>

      <div className="bg-gray-900/50 border border-gray-800 rounded-xl p-6">
        <p className="text-gray-500 text-center">Coming soon — Ocarina songs with note-button tracking</p>
      </div>
    </div>
  );
}
